import {
  ShowAlert,
  ShowConfirm,
  ShowMesage,
  openPage
} from "./client.handler.js";
import {
  getFormItem,
  updateFormItem,
  addTableRow,
  getTable,
  getTableRows,
  addTableRows,
  getTableRow,
  deleteTableRow,
  toJsonForm,
  getSelectedRows
} from "./form.handler.js";
import {
  formatToKfDate,
  formatToKfCurrency,
  formatToKfNumber,
  formatToKfBoolean
} from "./formatter.handler.js";
import { componentHandler } from "./component.handler.js";
import { customComponentHandler } from "./custom.component.handler.js";
import {
  setAppVariableSync,
  getAppVariable,
  getAppVariableSync,
  setAppVariable
} from "./application.handler.js";
import {
  getPageParams,
  getAllPageParams,
  closePopup,
  openPopup,
  getPageVariable,
  setPageVariable,
  getPageVariableSync,
  setPageVariableSync
} from "./page.handler.js";
import { dataformHandler } from "./dataform.handler.js";
import { boardHandler } from "./board.handler.js";
import { processHandler } from "./process.handler.js";
import { executeComponentEvent } from "./event.handlers.js";
import { getPopupParameter, getAllPopupParameters } from "./popup.handler.js";
import { fetchWithTimeout } from "./api.handler.js";
import { evaluateDecisionTable } from "./decisiontable.handler.js";
import { useAccountStore, useUserStore } from "../stores/index.js";
import { msgData, errorMsg } from "./utils.js";
import { LISTENER_CMDS, EVENT_TYPES } from "./constants.js";

class SDKHandler {
  constructor(sendTo, receiveIn) {
    this.sendTo = sendTo;
    this.receiveIn = receiveIn;
    this.listener = (e) => this.messageListener(e);
    this.receiveIn.addEventListener("message", this.listener);
  }

  onComplete() {}

  async messageListener(e) {
    if (this.sendTo.contentWindow && this.sendTo.contentWindow !== e.source)
      return;
    let data = e.data;
    let atomics;

    // // Temp : SharedArray buffer is disabled
    // if (isSharedArrayBuffer(data)) {
    //   atomics = new AtomicsHandler(data);
    //   data = atomics.load();
    // }

    if (!data?.command) return;

    // Components methods
    if (data.command.startsWith("COMPONENT_")) {
      let response = await componentHandler(data, this);
      response && this.postMessage({ ...response });
      return;
    }

    // custom component methods
    if (data.command.startsWith("CC_")) {
      let response = await customComponentHandler(data, this);
      response && this.postMessage({ ...response });
      return;
    }

    // dataform methods
    if (data.command.startsWith("DATAFORM_")) {
      let response = await dataformHandler(data, this);
      response && this.postMessage(response);
      return;
    }

    if (data.command.startsWith("BOARD_")) {
      let response = await boardHandler(data, this);
      response && this.postMessage(response);
      return;
    }

    if (data.command.startsWith("PROCESS_")) {
      let response = await processHandler(data, this);
      response && this.postMessage(response);
      return;
    }

    switch (data.command) {
      case LISTENER_CMDS.RETURN:
        return this.onComplete(e.data.data);

      case LISTENER_CMDS.API:
        try {
          let resp = await fetchWithTimeout(data.url, data.args);
          return this.postMessage({ _req: data, resp });
        } catch (err) {
          return this.postMessage({ _req: data, err });
        }

      case LISTENER_CMDS.OPEN_PAGE:
        return openPage(data);

      case LISTENER_CMDS.REDIRECT:
        window.location.href = data.url;
        return;

      case LISTENER_CMDS.MESSAGE:
        return ShowMesage(data);

      case LISTENER_CMDS.GET_FORM_FIELD: {
        let getFormValuePostmsg = getFormItem(this.formInstanceId, data);
        return this.postMessage({ ...getFormValuePostmsg });
      }

      case LISTENER_CMDS.GET_TABLE_ROW: {
        let getTableRowPostMsg = getTableRow(this.formInstanceId, data);
        return this.postMessage({ ...getTableRowPostMsg });
      }

      case LISTENER_CMDS.UPDATE_FORM: {
        let updateResp = updateFormItem(this.formInstanceId, data);
        return this.postMessage({ ...updateResp });
      }

      case LISTENER_CMDS.GET_TABLE: {
        let updateResp1 = getTable(this.formInstanceId, data);
        return this.postMessage({ ...updateResp1 });
      }

      case LISTENER_CMDS.ADD_TABLE_ROW: {
        let addTableRowResp = await addTableRow(this.formInstanceId, data);
        return this.postMessage({ ...addTableRowResp });
      }

      case LISTENER_CMDS.ADD_TABLE_ROWS: {
        let addTableRowsResp = await addTableRows(this.formInstanceId, data);
        return this.postMessage({ ...addTableRowsResp });
      }

      case LISTENER_CMDS.GET_TABLE_ROWS: {
        let addTableRowResp = getTableRows(this.formInstanceId, data);
        return this.postMessage({ ...addTableRowResp });
      }

      case LISTENER_CMDS.GET_SELECTED_TABLE_ROWS: {
        let selectedRows = getSelectedRows(this.formInstanceId, data);
        return this.postMessage({ ...selectedRows });
      }

      case LISTENER_CMDS.TO_JSON: {
        let toJsonMessage = toJsonForm(this.formInstanceId, data);
        return this.postMessage({ ...toJsonMessage });
      }

      case LISTENER_CMDS.DELETE_TABLE_ROW: {
        let deleteTableRowResp = await deleteTableRow(
          this.formInstanceId,
          data
        );
        return this.postMessage({ ...deleteTableRowResp });
      }

      case LISTENER_CMDS.ALERT:
        let alertPostMsg = await ShowAlert(data);
        return this.postMessage({ ...alertPostMsg });

      case LISTENER_CMDS.CONFIRM:
        let confirmPostMsg = await ShowConfirm(data);
        return this.postMessage({ ...confirmPostMsg });

      case LISTENER_CMDS.FORMAT_DATE:
        let dateResponse = await formatToKfDate(data, false);
        return this.postMessage({ ...dateResponse });

      case LISTENER_CMDS.FORMAT_DATE_TIME:
        let dateTimeResponse = await formatToKfDate(data, true);
        return this.postMessage({ ...dateTimeResponse });

      case LISTENER_CMDS.FORMAT_NUMBER:
        let numberResponse = await formatToKfNumber(data);
        return this.postMessage({ ...numberResponse });

      case LISTENER_CMDS.FORMAT_CURRENCY:
        let currencyResponse = formatToKfCurrency(data);
        return this.postMessage({ ...currencyResponse });

      case LISTENER_CMDS.FORMAT_BOOLEAN:
        let booleanResponse = formatToKfBoolean(data);
        return this.postMessage({ ...booleanResponse });

      case LISTENER_CMDS.GET_APP_VARIABLE: {
        if (atomics) return getAppVariableSync(data, atomics);

        let getResponse = getAppVariable(data);
        return this.postMessage({ ...getResponse });
      }

      case LISTENER_CMDS.SET_APP_VARIABLE: {
        if (atomics) return setAppVariableSync(data, atomics);

        let setResponse = setAppVariable(data);
        return this.postMessage({ ...setResponse });
      }

      case LISTENER_CMDS.DECISION_TABLE_EXECUTE: {
        let getResponse = await evaluateDecisionTable(data);
        return this.postMessage({ ...getResponse });
      }

      case LISTENER_CMDS.GET_PAGE_VARIABLE: {
        if (atomics) return getPageVariableSync(this.pageId, data, atomics);

        let getResponse = getPageVariable(this.pageId, data);
        return this.postMessage({ ...getResponse });
      }

      case LISTENER_CMDS.SET_PAGE_VARIABLE: {
        if (atomics) return setPageVariableSync(this.pageId, data, atomics);

        let setResponse = setPageVariable(this.pageId, data);
        return this.postMessage({ ...setResponse });
      }

      case LISTENER_CMDS.GET_PAGE_PARAMS: {
        let getResponse = getPageParams(this.pageId, data);
        return this.postMessage({ ...getResponse });
      }

      case LISTENER_CMDS.GET_ALL_PAGE_PARAMS: {
        let getResponse = getAllPageParams(this.pageId, data);
        return this.postMessage({ ...getResponse });
      }

      case LISTENER_CMDS.CLOSE_POPUP: {
        let getResponse = closePopup(this.pageId, data);
        return this.postMessage({ ...getResponse });
      }

      case LISTENER_CMDS.OPEN_POPUP: {
        let popupResp = openPopup(this.pageId, data);
        return this.postMessage({ ...popupResp });
      }

      case LISTENER_CMDS.GET_CONTEXT: {
        try {
          let accountDetails = await useAccountStore
            .getState()
            .getAccountDetails();
          let { Name, Email, _id } = accountDetails.UserDetails;
          let currentAppId = await useUserStore.getState().currentAppId;
          let executionContext = {
            app: {
              _id: currentAppId
            },
            page: {
              _id: this.pageId
            },
            user: { Name, Email, _id },
            account: { _id: accountDetails._id }
          };
          let ctxResp = msgData(data, {
            ...executionContext
          });
          return this.postMessage({ ...ctxResp });
        } catch (e) {
          return errorMsg(data, e);
        }
      }

      case LISTENER_CMDS.GET_POPUP_PARAMS: {
        let getPopupParamsResp = getPopupParameter(this.pageId, data);
        return this.postMessage({ ...getPopupParamsResp });
      }

      case LISTENER_CMDS.GET_ALL_POPUP_PARAMS: {
        let getAllPopupParamsResp = getAllPopupParameters(this.pageId, data);
        return this.postMessage({ ...getAllPopupParamsResp });
      }

      default: {
        console.warn("Command not specified", data);
      }
    }
  }

  removeListener() {
    this.receiveIn.removeEventListener("message", this.listener);
  }

  postEventMessage(eventDetails, eventParams) {
    this.postMessage({
      isEvent: true,
      eventParams,
      ...eventDetails
    });
  }

  updateContext(key, value) {
    this[key] = value;
  }
}

export class WindowHandler extends SDKHandler {
  constructor({ iframe, componentId, params }) {
    super(iframe, window);
    this.queue = [];
    this.componentId = componentId;
    this.params = params;
  }

  postMessage(data) {
    if (this.sendTo?.contentWindow) {
      if (this.queue.length > 0) {
        this.queue.forEach((queueData) =>
          this.sendTo.contentWindow.postMessage(queueData, "*")
        );
        this.queue = [];
      }
      this.sendTo.contentWindow.postMessage(data, "*");
    } else {
      this.queue.push(data);
    }
  }

  sendParams(data) {
    this.params = data;
    executeComponentEvent(
      {
        id: this.componentId,
        eventName: EVENT_TYPES.CC_ON_PARAMS_CHANGE,
        executeOnce: false
      },
      data
    );
  }

  terminate() {
    this.sendTo = undefined;
    this.removeListener();
  }
}

export class WorkerHandler extends SDKHandler {
  constructor(workerPath) {
    const worker = new Worker(workerPath, { type: "module" });
    super(worker, worker);
    this.workerInstance = worker;
    this.workerExecutionTimeout = null;
    this.executionContext = {};
  }

  postMessage(data) {
    // To sanitise and remove methods on data if any
    data = JSON.parse(JSON.stringify(data));
    this.sendTo.postMessage(data);
  }

  executeCode({ code, options, args = {}, context }) {
    let { canTerminate } = options;
    return new Promise(async (resolve, reject) => {
      if (canTerminate) {
        this.workerExecutionTimeout = window.setTimeout(() => {
          this.workerInstance.terminate();
          reject({ resp: "code execution time took longer than 1 minute" });
        }, 1000 * 60);
      }

      this.postMessage({
        command: "EXECUTE",
        code,
        executionContext: {
          ...context,
          csrfToken: window?.accountDetails?.AuthToken
        },
        eventParameters: { ...args }
      });

      for (let key in context) {
        context?.[key] && this.updateContext(key, context[key]);
      }
      this.executionContext = { context, args };

      this.onComplete = (data) => {
        if (canTerminate && this.workerExecutionTimeout) {
          window.clearTimeout(this.workerExecutionTimeout);
        }
        resolve(data);
      };
    });
  }

  terminateWorker() {
    // should delete worker instance from pageStore
    this.removeListener();
    this.workerInstance.terminate();
  }
}

export class AtomicsHandler {
  constructor(sab) {
    this.sab = sab;
    this.int32Array = new Int32Array(this.sab);
  }

  #textEncoder = new TextEncoder();
  #textDecoder = new TextDecoder();

  load() {
    return this.decodeData();
  }

  store(data) {
    let encodedData = this.encodeData(data);
    this.int32Array.set(encodedData, 0);
  }

  notify() {
    // eslint-disable-next-line no-undef
    Atomics.notify(this.int32Array, 0, 1);
  }

  encodeData(data) {
    const replacer = (key, value) =>
      value === undefined ? "undefined" : value;
    let string = JSON.stringify(data, replacer);
    let encodedData = this.#textEncoder.encode(string);

    return encodedData;
  }

  decodeData() {
    let uInt8Array = new Uint8Array(this.int32Array);
    let string = this.#textDecoder
      .decode(uInt8Array)
      // eslint-disable-next-line no-control-regex
      .replaceAll(/\x00/g, "");
    return JSON.parse(string);
  }
}

export * from "./event.handlers.js";
